import {} from "./mutation";

export default {
  namespaced: true,
};
